import { SignatureAction } from "@enums/signatureAction";
import { SignatureModule } from "@enums/signatureModule";
import apiInstance from "@services/Shared/instanceAxios";
import { AxiosPromise } from "axios";

const postFilesToSignService = (
  uuid: string,
  files: string[],
  module: SignatureModule,
  action?: SignatureAction
): AxiosPromise<Record<string, string>> =>
  apiInstance({
    url: `/authentication/storage/${uuid}/files-to-sign`,
    params: {
      ...(action
        ? {
            action,
          }
        : {}),
      module,
    },
    method: "post",
    maxBodyLength: Infinity,
    data: { files },
    transformResponse: (data) => {
      return JSON.parse(data).signedUrls;
    },
  });

export default postFilesToSignService;
